'use client';
import { v4 } from 'uuid';
import toMimeType from './toMimeType';
export default function filePrompt({ id = v4(), name = 'file', multiple, accept = [] }) {
    return new Promise((resolve) => {
        const el = document.createElement('div');
        let input = `<input id=${id} name=${name} type="file"`;
        if (multiple) {
            input += ' multiple';
        }
        if (accept.length) {
            input += ` accept="${accept.map(toMimeType).join(',')}"`;
        }
        input += '>';
        el.innerHTML = input;
        const fileInput = el.firstChild;
        fileInput.addEventListener('change', () => {
            resolve(fileInput.files);
        });
        fileInput.click();
        fileInput.removeEventListener('change', resolve);
    });
}
